import auth0 from 'auth0-js';

export default new auth0.WebAuth({
  domain: 'cloudchefsonline.eu.auth0.com',
  clientID: process.env.REACT_APP_AUTH_CLIENT_ID,
  redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
  responseType: 'token id_token',
  scope: 'openid profile'
});